export const boardAdminCopy = {
  en: {
    title: 'Board',
    intro: 'One edition, three languages. Prepare the next shelf and quiz for Belore readers.',
    picks: 'Picks',
    quizzes: 'Quizzes',
    team: 'Team',
    moderation: 'Moderation',
    create: 'Create draft',
    edit: 'Edit',
    back: 'Back to list',
    save: 'Save changes',
    publish: 'Publish now',
    schedule: 'Schedule',
    archive: 'Archive',
    end: 'End quiz',
    draft: 'Return to draft',
    remove: 'Delete draft',
    refresh: 'Refresh',
    loading: 'Loading…',
    empty: 'Nothing here yet.',
    error: 'Could not complete the request. Try again.',
    conflict: 'This item changed. Reload the saved version before editing again.',
    unsaved: 'Save changes before publishing or scheduling.',
    saved: 'Saved',
    month: 'Month',
    publishAt: 'Publish at',
    starts: 'Starts',
    ends: 'Ends',
    quizTitle: 'Title',
    introLabel: 'Introduction',
    host: 'Quiz host',
    chooseHost: 'Choose a team member',
    reason: 'Reason',
    prompt: 'Question prompt',
    addPick: 'Add a pick',
    addQuestion: 'Add question',
    question: 'Question',
    removeItem: 'Remove',
    up: 'Move up',
    down: 'Move down',
    search: 'Search',
    query: 'Catalogue title, author or ISBN',
    choose: 'Choose',
    chooseWork: 'Choose a catalogue work',
    change: 'Change book',
    noResults: 'No matches found.',
    editionMissing: 'Catalogue edition unavailable:',
    isbnRequired: 'This search result needs an ISBN before it can be added.',
    preview: 'Preview',
    counts: 'Live answers',
    answers: 'readers answered',
    locked:
      'Answers have arrived. Questions, their order and book options are locked; copy remains editable.',
    requirements: 'Before publishing',
    account: 'Account name or id',
    enabled: 'Belore team',
    role: 'Role label',
    hidden: 'Hidden items',
    target: 'Content or item id',
    kind: 'Content type',
    review: 'Review',
    line: 'Line',
    team_book: 'Team book',
    hide: 'Hide from Board',
    unhide: 'Unhide',
    hiddenBy: 'Hidden by',
    hiddenAt: 'Hidden at',
    statuses: {
      draft: 'Draft',
      scheduled: 'Scheduled',
      published: 'Published',
      archived: 'Archived',
      active: 'Active',
      ended: 'Ended',
    },
  },
  sk: {
    title: 'Nástenka',
    intro: 'Jedno vydanie, tri jazyky. Pripravte ďalšiu poličku a kvíz pre čitateľov Belore.',
    picks: 'Odporúčania',
    quizzes: 'Kvízy',
    team: 'Tím',
    moderation: 'Moderovanie',
    create: 'Vytvoriť koncept',
    edit: 'Upraviť',
    back: 'Späť na zoznam',
    save: 'Uložiť zmeny',
    publish: 'Zverejniť teraz',
    schedule: 'Naplánovať',
    archive: 'Archivovať',
    end: 'Ukončiť kvíz',
    draft: 'Vrátiť do konceptu',
    remove: 'Odstrániť koncept',
    refresh: 'Obnoviť',
    loading: 'Načítava sa…',
    empty: 'Zatiaľ tu nič nie je.',
    error: 'Požiadavku sa nepodarilo dokončiť. Skúste znova.',
    conflict: 'Položka sa zmenila. Pred úpravami načítajte uloženú verziu.',
    unsaved: 'Pred zverejnením alebo naplánovaním uložte zmeny.',
    saved: 'Uložené',
    month: 'Mesiac',
    publishAt: 'Zverejniť',
    starts: 'Začiatok',
    ends: 'Koniec',
    quizTitle: 'Názov',
    introLabel: 'Úvod',
    host: 'Hostiteľ kvízu',
    chooseHost: 'Vyberte člena tímu',
    reason: 'Dôvod',
    prompt: 'Znenie otázky',
    addPick: 'Pridať odporúčanie',
    addQuestion: 'Pridať otázku',
    question: 'Otázka',
    removeItem: 'Odstrániť',
    up: 'Posunúť nahor',
    down: 'Posunúť nadol',
    search: 'Hľadať',
    query: 'Názov knihy, autor alebo ISBN',
    choose: 'Vybrať',
    chooseWork: 'Vyberte dielo z katalógu',
    change: 'Zmeniť knihu',
    noResults: 'Žiadne výsledky.',
    editionMissing: 'Vydanie v katalógu nie je dostupné:',
    isbnRequired: 'Tento výsledok potrebuje ISBN, aby sa dal pridať.',
    preview: 'Náhľad',
    counts: 'Priebežné odpovede',
    answers: 'čitateľov odpovedalo',
    locked:
      'Kvíz už má odpovede. Otázky, ich poradie a možnosti sú zamknuté; texty môžete upravovať.',
    requirements: 'Pred zverejnením',
    account: 'Meno alebo id účtu',
    enabled: 'Tím Belore',
    role: 'Označenie roly',
    hidden: 'Skryté položky',
    target: 'Obsah alebo id položky',
    kind: 'Typ obsahu',
    review: 'Recenzia',
    line: 'Citát',
    team_book: 'Kniha člena tímu',
    hide: 'Skryť z nástenky',
    unhide: 'Zobraziť',
    hiddenBy: 'Skryl',
    hiddenAt: 'Skryté',
    statuses: {
      draft: 'Koncept',
      scheduled: 'Naplánované',
      published: 'Zverejnené',
      archived: 'Archivované',
      active: 'Aktívne',
      ended: 'Ukončené',
    },
  },
  cs: {
    title: 'Nástěnka',
    intro: 'Jedno vydání, tři jazyky. Připravte další poličku a kvíz pro čtenáře Belore.',
    picks: 'Doporučení',
    quizzes: 'Kvízy',
    team: 'Tým',
    moderation: 'Moderování',
    create: 'Vytvořit koncept',
    edit: 'Upravit',
    back: 'Zpět na seznam',
    save: 'Uložit změny',
    publish: 'Zveřejnit nyní',
    schedule: 'Naplánovat',
    archive: 'Archivovat',
    end: 'Ukončit kvíz',
    draft: 'Vrátit do konceptu',
    remove: 'Odstranit koncept',
    refresh: 'Obnovit',
    loading: 'Načítání…',
    empty: 'Zatím tu nic není.',
    error: 'Požadavek se nepodařilo dokončit. Zkuste to znovu.',
    conflict: 'Položka se změnila. Před úpravami načtěte uloženou verzi.',
    unsaved: 'Před zveřejněním nebo naplánováním uložte změny.',
    saved: 'Uloženo',
    month: 'Měsíc',
    publishAt: 'Zveřejnit',
    starts: 'Začátek',
    ends: 'Konec',
    quizTitle: 'Název',
    introLabel: 'Úvod',
    host: 'Hostitel kvízu',
    chooseHost: 'Vyberte člena týmu',
    reason: 'Důvod',
    prompt: 'Znění otázky',
    addPick: 'Přidat doporučení',
    addQuestion: 'Přidat otázku',
    question: 'Otázka',
    removeItem: 'Odstranit',
    up: 'Posunout nahoru',
    down: 'Posunout dolů',
    search: 'Hledat',
    query: 'Název knihy, autor nebo ISBN',
    choose: 'Vybrat',
    chooseWork: 'Vyberte dílo z katalogu',
    change: 'Změnit knihu',
    noResults: 'Žádné výsledky.',
    editionMissing: 'Vydání v katalogu není dostupné:',
    isbnRequired: 'Tento výsledek potřebuje ISBN, aby jej bylo možné přidat.',
    preview: 'Náhled',
    counts: 'Průběžné odpovědi',
    answers: 'čtenářů odpovědělo',
    locked:
      'Kvíz už má odpovědi. Otázky, jejich pořadí a možnosti jsou zamknuté; texty můžete upravovat.',
    requirements: 'Před zveřejněním',
    account: 'Jméno nebo id účtu',
    enabled: 'Tým Belore',
    role: 'Označení role',
    hidden: 'Skryté položky',
    target: 'Obsah nebo id položky',
    kind: 'Typ obsahu',
    review: 'Recenze',
    line: 'Citát',
    team_book: 'Kniha člena týmu',
    hide: 'Skrýt z nástěnky',
    unhide: 'Zobrazit',
    hiddenBy: 'Skryl',
    hiddenAt: 'Skryto',
    statuses: {
      draft: 'Koncept',
      scheduled: 'Naplánováno',
      published: 'Zveřejněno',
      archived: 'Archivováno',
      active: 'Aktivní',
      ended: 'Ukončeno',
    },
  },
};
